/* @flow */
/* Do not edit - Generated by iconify. See README.md for more details. */
/* eslint-disable max-len */
import type { ElementConfig as ReactElementConfig } from "react"

import BaseIcon from "./BaseIcon";

export default class SvgIconRemoveFromCompare extends BaseIcon {
    static defaultProps: ReactElementConfig<typeof BaseIcon> = {
        iconClass: "RemoveFromCompareIcon",
    }

    svgContent: string = `
        <svg class='${this.classNames}' width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="1.33333" y="1.33333" width="29.3333" height="29.3333" stroke="#4C13AE" stroke-width="2.66667"/><line x1="25.3333" y1="16" x2="6.66659" y2="16" stroke="#4C13AE" stroke-width="2.66667"/></svg>
    `;
}
